import { render, staticRenderFns } from "./FormDuplicateBtn.vue?vue&type=template&id=99400108"
import script from "./FormDuplicateBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDuplicateBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports